export { default as AutoAwesomeIcon } from "@mui/icons-material/AutoAwesome";
